/**
 * Singleton instance of DeepDiveRouter with all mini-games registered.
 * Separated from app.js to avoid pulling in Grafana SDK dependencies.
 */

import { DeepDiveRouter } from './deepDiveRouter.js';
import { WhoSaidItGame } from './minigames/whoSaidIt.js';
import { MatchDefinitionGame } from './minigames/matchDefinition.js';
import { PutInOrderGame } from './minigames/putInOrder.js';
import { TimelineGame } from './minigames/timeline.js';
import { GroupThemGame } from './minigames/groupThem.js';
import { FindPartnerGame } from './minigames/findPartner.js';
import { OutlierGame } from './minigames/outlier.js';

// Initialize Deep Dive Router
const deepDiveRouter = new DeepDiveRouter();
deepDiveRouter.registerMechanic('who-said-it', WhoSaidItGame);
deepDiveRouter.registerMechanic('match-the-definition', MatchDefinitionGame);
deepDiveRouter.registerMechanic('put-in-order', PutInOrderGame);
deepDiveRouter.registerMechanic('timeline-challenge', TimelineGame);
deepDiveRouter.registerMechanic('group-them', GroupThemGame);
deepDiveRouter.registerMechanic('find-the-partner', FindPartnerGame);
deepDiveRouter.registerMechanic('outlier', OutlierGame);

export { deepDiveRouter };
